import { take, put, call, all, takeLatest } from 'redux-saga/effects';
import moment from 'moment';

import {
  initPageInfo,
  requestPageStart,
  requestPageSuccess,
  requestPageFail,

  patchPageStart,
  patchPageSuccess,
  patchPageFail,

  postPageStart,
  postPageSuccess,
  postPageFail,

  putPageStart,
  putPageSuccess,
  putPageFail,

  deletePageStart,
  deletePageSuccess,
  deletePageFail,

  multipleDeletePageStart,
  multipleDeletePageSuccess,
  multipleDeletePageFail,

  requestDetailPageStart,
  requestDetailPageSuccess,
  requestDetailPageFail,

  postSectionStart,
  postSectionSuccess,
  postSectionFail,

  postSectionItemStart,
  postSectionItemSuccess,
  postSectionItemFail,

  putSectionItemStart,
  putSectionItemSuccess,
  putSectionItemFail,

  deleteSectionItemStart,
  deleteSectionItemSuccess,
  deleteSectionItemFail,

  patchSectionStart,
  patchSectionSuccess,
  patchSectionFail,

  putSectionStart,
  putSectionSuccess,
  putSectionFail,

  deleteSectionStart,
  deleteSectionSuccess,
  deleteSectionFail,

  requestProductGroupFail,
  requestProductGroupStart,
  requestProductGroupSuccess,

  postProductGroupFail,
  postProductGroupStart,
  postProductGroupSuccess,

  putProductGroupFail,
  putProductGroupStart,
  putProductGroupSuccess,

  deleteProductGroupFail,
  deleteProductGroupStart,
  deleteProductGroupSuccess,

  multipleDeleteProductGroupFail,
  multipleDeleteProductGroupStart,
  multipleDeleteProductGroupSuccess,

  requestDetailProductGroupFail,
  requestDetailProductGroupStart,
  requestDetailProductGroupSuccess,

  deleteItemFail,
  deleteItemStart,
  deleteItemSuccess,

} from '../actions/home-management';

import requestManagement from '../service/requestManagement';
const { method_POST, method_GET, method_PATCH, method_PUT, method_DELETE, method_MULTIPLE_DELETE } = requestManagement;

import CONFIG from '@root/config/config.next';
const url = CONFIG.backendEndpoint;

export function* requestPage({ payload }) {

  /*console.log('[sages] requestPage : ', payload);*/

  const apiURL = `${url}/backend/v2/cms`;

  //====================================================================================================================

  try {
    const data = yield method_GET(
      {
        url: apiURL,
        params: {
          "pagination[page]": payload.page === 0 ? 1 : payload.page,
          "pagination[limit]": payload.limit,
          "sort[field]": payload.field,
          "sort[order]": payload.order,
          "filter[status]": payload.status,
          "filter[q]": payload.q,
        }
      });

    /*console.log("[requestPage] GET : ", { ...data });*/

    const { error } = data;

    if (Boolean(error)) {

      const { data: error_data } = error;

      /*console.log("[requestPage] GET : [error_data]", error_data);*/

      yield put(requestPageFail(error_data));
    }
    else
      yield put(requestPageSuccess(data));

  } catch (error) {
    yield put(requestPageFail(error));
  }

  //====================================================================================================================
}

export function* patchPage({ payload }) {

  /*console.log('[sages] patchPage : ', payload);*/

  const apiURL = `${url}/backend/v2/cms/${payload?.uuid}`;

  //====================================================================================================================

  try {
    const data = yield method_PATCH(
      {
        url: apiURL,
        data: payload?.data
      });

    /*console.log("[API] GET : ",);*/

    yield put(patchPageSuccess(data));

  } catch (error) {
    yield put(patchPageFail(error));
  }

  //====================================================================================================================
}

export function* postPage({ payload }) {

  /*console.log('[sages] postPage : ', payload);*/

  const apiURL = `${url}/backend/v2/cms`;

  //====================================================================================================================

  try {
    const data = yield method_POST(
      {
        url: apiURL,
        data: payload?.data
      });

    /*console.log("[API] GET : ",);*/

    yield put(postPageSuccess(data));

  } catch (error) {
    yield put(postPageFail(error));
  }

  //====================================================================================================================
}

export function* putPage({ payload }) {

  /*console.log('[sages] putPage : ', payload);*/

  const apiURL = `${url}/backend/v2/cms/${payload?.uuid}`;

  //====================================================================================================================

  try {
    const data = yield method_PUT(
      {
        url: apiURL,
        data: payload?.data
      });

    /*console.log("[API] GET : ",);*/

    yield put(putPageSuccess(data));

  } catch (error) {
    yield put(putPageFail(error));
  }

  //====================================================================================================================
}

export function* deletePage({ payload }) {

  /*console.log('[sages] deletePage : ', payload);*/

  const apiURL = `${url}/backend/v2/cms/${payload?.uuid}`;

  //====================================================================================================================

  try {
    const data = yield method_DELETE(
      {
        url: apiURL,
      });

    /*console.log("[API] GET : ",);*/

    yield put(deletePageSuccess(data));

  } catch (error) {
    yield put(deletePageFail(error));
  }

  //====================================================================================================================
}

export function* multipleDeletePage({ payload }) {

  /*console.log('[sages] multipleDeletePage : ', payload);*/

  const apiURL = `${url}/backend/v2/cms`;

  //====================================================================================================================

  try {
    const data = yield method_MULTIPLE_DELETE(
      {
        url: apiURL,
        array: payload?.array
      });

    /*console.log("[API] MULTIPLE DELETE : ",);*/

    yield put(multipleDeletePageSuccess(data));

  } catch (error) {
    yield put(multipleDeletePageFail(error));
  }

  //====================================================================================================================
}

export function* requestDetailPage({ payload }) {

  /*console.log('[sages] requestDetailPage : ', payload);*/

  const apiURL = `${url}/backend/v2/cms/${payload?.uuid}`;

  //====================================================================================================================

  try {
    const data = yield method_GET(
      {
        url: apiURL,
      });

    /*console.log("[API] GET : ",);*/

    yield put(requestDetailPageSuccess(data));

  } catch (error) {
    yield put(requestDetailPageFail(error));
  }

  //====================================================================================================================
}

export function* postSection({ payload }) {

  /*console.log('[sages] postSection : ', payload);*/

  const apiURL = `${url}/backend/v2/cms/${payload?.uuid}/section`;

  //====================================================================================================================

  try {
    const data = yield method_POST(
      {
        url: apiURL,
        data: payload?.data
      });

    /*console.log("[API] GET : ",);*/

    yield put(postSectionSuccess(data));

  } catch (error) {
    yield put(postSectionFail(error));
  }

  //====================================================================================================================
}

export function* postSectionItem({ payload }) {

  /*console.log('[sages] postSectionItem : ', payload);*/

  const apiURL = `${url}/backend/v2/cms/${payload?.page_uuid}/section/${payload?.section_uuid}/item`;

  //====================================================================================================================

  try {
    const data = yield method_POST(
      {
        url: apiURL,
        data: payload?.data
      });

    /*console.log("[API] GET : ",);*/

    yield put(postSectionItemSuccess(data));

  } catch (error) {
    yield put(postSectionItemFail(error));
  }

  //====================================================================================================================
}

export function* putSectionItem({ payload }) {

  /*console.log('[sages] putSectionItem : ', payload);*/

  const apiURL = `${url}/backend/v2/cms/${payload?.page_uuid}/section/${payload?.section_uuid}/item/${payload?.item_uuid}`;

  //====================================================================================================================

  try {
    const data = yield method_PUT(
      {
        url: apiURL,
        data: payload?.data
      });

    /*console.log("[API] GET : ",);*/

    yield put(putSectionItemSuccess(data));

  } catch (error) {
    yield put(putSectionItemFail(error));
  }

  //====================================================================================================================
}

export function* deleteSectionItem({ payload }) {

  /*console.log('[sages] deleteSectionItem : ', payload);*/

  const apiURL = `${url}/backend/v2/cms/${payload?.page_uuid}/section/${payload?.section_uuid}/item/${payload?.item_uuid}`;

  //====================================================================================================================

  try {
    const data = yield method_DELETE(
      {
        url: apiURL,
      });

    /*console.log("[API] DELETE : ",);*/

    yield put(deleteSectionItemSuccess(data));

  } catch (error) {
    yield put(deleteSectionItemFail(error));
  }

  //====================================================================================================================
}


export function* patchSection({ payload }) {

  /*console.log('[sages] patchSection : ', payload);*/

  const apiURL = `${url}/backend/v2/cms/${payload?.page_uuid}/section/${payload?.section_uuid}`;

  //====================================================================================================================

  try {
    const data = yield method_PATCH(
      {
        url: apiURL,
        data: payload?.data
      });

    /*console.log("[API] GET : ",);*/

    yield put(patchSectionSuccess(data));

  } catch (error) {
    yield put(patchSectionFail(error));
  }

  //====================================================================================================================
}

export function* putSection({ payload }) {

  /*console.log('[sages] putSection : ', payload);*/

  const apiURL = `${url}/backend/v2/cms/${payload?.page_uuid}/section/${payload?.section_uuid}`;

  //====================================================================================================================

  try {
    const data = yield method_PUT(
      {
        url: apiURL,
        data: payload?.data
      });

    /*console.log("[API] GET : ",);*/

    yield put(putSectionSuccess(data));

  } catch (error) {
    yield put(putSectionFail(error));
  }

  //====================================================================================================================
}

export function* deleteSection({ payload }) {

  /*console.log('[sages] deleteSection : ', payload);*/

  const apiURL = `${url}/backend/v2/cms/${payload?.page_uuid}/section/${payload?.section_uuid}`;

  //====================================================================================================================

  try {
    const data = yield method_DELETE(
      {
        url: apiURL,
      });

    /*console.log("[API] GET : ",);*/

    yield put(deleteSectionSuccess(data));

  } catch (error) {
    yield put(deleteSectionFail(error));
  }

  //====================================================================================================================
}

export function* requestProductGroup({ payload }) {

  /*console.log('[sages] requestProductGroup : ', payload);*/

  const apiURL = `${url}/backend/v2/cms/${payload?.uuid}/group`;

  //====================================================================================================================

  try {
    const data = yield method_GET(
      {
        url: apiURL,
        params: {
          "pagination[page]": payload.page === 0 ? 1 : payload.page,
          "pagination[limit]": payload.limit,
          "sort[field]": payload.field,
          "sort[order]": payload.order,
        }
      });

    /*console.log("[API] GET : ",);*/

    yield put(requestProductGroupSuccess(data));

  } catch (error) {
    yield put(requestProductGroupFail(error));
  }

  //====================================================================================================================
}

export function* postProductGroup({ payload }) {

  /*console.log('[sages] postProductGroup : ', payload);*/

  const apiURL = `${url}/backend/v2/cms/${payload?.uuid}/group`;

  //====================================================================================================================

  try {
    const data = yield method_POST(
      {
        url: apiURL,
        data: payload?.data
      });

    /*console.log("[API] GET : ",);*/

    yield put(postProductGroupSuccess(data));

  } catch (error) {
    yield put(postProductGroupFail(error));
  }

  //====================================================================================================================
}

export function* putProductGroup({ payload }) {

  /*console.log('[sages] putProductGroup : ', payload);*/

  const apiURL = `${url}/backend/v2/cms/${payload?.template_uuid}/group/${payload?.product_group_uuid}`;

  //====================================================================================================================

  try {
    const data = yield method_PUT(
      {
        url: apiURL,
        data: payload?.data
      });

    /*console.log("[API] GET : ",);*/

    yield put(putProductGroupSuccess(data));

  } catch (error) {
    yield put(putProductGroupFail(error));
  }

  //====================================================================================================================
}

export function* deleteProductGroup({ payload }) {

  /*console.log('[sages] deleteProductGroup : ', payload);*/

  const apiURL = `${url}/backend/v2/cms/${payload?.template_uuid}/group/${payload?.product_group_uuid}`;

  //====================================================================================================================

  try {
    const data = yield method_DELETE(
      {
        url: apiURL,
      });

    /*console.log("[API] GET : ",);*/

    yield put(deleteProductGroupSuccess(data));

  } catch (error) {
    yield put(deleteProductGroupFail(error));
  }

  //====================================================================================================================
}

export function* multipleDeleteProductGroup({ payload }) {

  /*console.log('[sages] multipleDeleteProductGroup : ', payload);*/

  const apiURL = `${url}/backend/v2/cms/${payload?.uuid}/group`;

  //====================================================================================================================

  try {
    const data = yield method_MULTIPLE_DELETE(
      {
        url: apiURL,
        array: payload?.array
      });

    /*console.log("[API] MULTIPLE DELETE : ",);*/

    yield put(multipleDeleteProductGroupSuccess(data));

  } catch (error) {
    yield put(multipleDeleteProductGroupFail(error));
  }

  //====================================================================================================================
}

export function* requestDetailProductGroup({ payload }) {

  /*console.log('[sages] requestDetailProductGroup : ', payload);*/

  const apiURL = `${url}/backend/v2/cms/${payload?.group_uuid}/group/${payload?.uuid}`;

  //====================================================================================================================

  try {
    const data = yield method_GET(
      {
        url: apiURL,
      });

    /*console.log("[API] GET : ",);*/

    yield put(requestDetailProductGroupSuccess(data));

  } catch (error) {
    yield put(requestDetailProductGroupFail(error));
  }

  //====================================================================================================================
}

export function* deleteItem({ payload }) {

  /*console.log('[sages] deleteItem : ', payload);*/

  const apiURL = `${url}/backend/v2/cms/${payload?.page_uuid}/section/${payload?.section_uuid}/item/${payload.item_uuid}`;

  //====================================================================================================================

  try {
    const data = yield method_DELETE(
      {
        url: apiURL,
      });

    /*console.log("[API] GET : ",);*/

    yield put(deleteItemSuccess(data));

  } catch (error) {
    yield put(deleteItemFail(error));
  }

  //====================================================================================================================
}


export function* watchHomeManagement() {

  /*console.log('[sages] watchPage : ✅');*/

  yield all([
    takeLatest(requestPageStart, requestPage),
    takeLatest(patchPageStart, patchPage),
    takeLatest(postPageStart, postPage),
    takeLatest(putPageStart, putPage),
    takeLatest(deletePageStart, deletePage),
    takeLatest(multipleDeletePageStart, multipleDeletePage),
    takeLatest(requestDetailPageStart, requestDetailPage),
    takeLatest(postSectionStart, postSection),
    takeLatest(postSectionItemStart, postSectionItem),
    takeLatest(putSectionItemStart, putSectionItem),
    takeLatest(deleteSectionItemStart, deleteSectionItem),
    takeLatest(patchSectionStart, patchSection),
    takeLatest(putSectionStart, putSection),
    takeLatest(deleteSectionStart, deleteSection),

    takeLatest(postProductGroupStart, postProductGroup),
    takeLatest(putProductGroupStart, putProductGroup),
    takeLatest(requestProductGroupStart, requestProductGroup),
    takeLatest(deleteProductGroupStart, deleteProductGroup),
    takeLatest(multipleDeleteProductGroupStart, multipleDeleteProductGroup),
    takeLatest(requestDetailProductGroupStart, requestDetailProductGroup),
    takeLatest(deleteItemStart, deleteItem),
  ])
}



